module.exports = __webpack_public_path__ + "img/cloud-lightning.789f759d.svg";